module.exports = "/images/screens.jpg?e8d9309a8c327eec156578def846f9ab";